"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formControl = void 0;
const border_1 = require("./border");
const colors_1 = require("./colors");
exports.formControl = {
    states: {
        enabled: {
            borderBottom: `${border_1.border.width.borderXs} ${border_1.border.style.solid} ${colors_1.colors.FormControl.text.enabled}`,
        },
        disabled: {
            borderBottom: `${border_1.border.width.borderXs} ${border_1.border.style.solid} ${colors_1.colors.FormControl.text.disabled}`,
        },
        error: {
            borderBottom: `${border_1.border.width.borderXs} ${border_1.border.style.solid} ${colors_1.colors.FormControl.text.error}`,
        },
        locked: {
            borderBottom: `${border_1.border.width.borderXs} ${border_1.border.style.solid} ${colors_1.colors.FormControl.text.locked}`,
        },
        success: {
            borderBottom: `${border_1.border.width.borderXs} ${border_1.border.style.solid} ${colors_1.colors.FormControl.text.success}`,
        },
        warning: {
            borderBottom: `${border_1.border.width.borderXs} ${border_1.border.style.solid} ${colors_1.colors.FormControl.text.warning}`,
        },
    },
};
//# sourceMappingURL=formControl.js.map